import {
  collection,
  FirestoreDataConverter,
  limit,
  orderBy,
  query,
} from 'firebase/firestore';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { firestore } from '@/lib/firebase';

export interface SmsLogEntry {
  id?: string;
  sentAt: Date | null;
  recipients: string[];
  message: string;
  boxes?: string[];
  sent?: string[];
  failed?: { to: string; error: string }[];
}

const converter: FirestoreDataConverter<SmsLogEntry> = {
  toFirestore: () => {
    throw new Error('smsLog is written by the agent only');
  },
  fromFirestore: (snapshot) => {
    const d = snapshot.data();
    return {
      id: snapshot.id,
      sentAt: d.sentAt?.toDate?.() ?? null,
      recipients: d.recipients ?? [],
      message: d.message ?? '',
      boxes: d.boxes ?? [],
      sent: d.sent ?? [],
      failed: d.failed ?? [],
    };
  },
};

/** Most recent sent SMS (newest first). Single-field sort → no composite index. */
export function useSmsLog(max = 100) {
  return useCollectionData(
    query(
      collection(firestore, 'smsLog').withConverter(converter),
      orderBy('sentAt', 'desc'),
      limit(max)
    ),
    { snapshotListenOptions: { includeMetadataChanges: false } }
  );
}
